export default function getUrl() {
    return process.env.VUE_APP_MAIN_URL
}
